/**
 * @author vishwadeep.kapoor
 * @Date: 2020-12-11 22:20:07
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2020-12-11 23:11:03
 */

const mandatory = { required: true, message: 'This Field is Mandatory' };
const email_valid = { type: 'email', message: 'The input is not valid E-mail!' };
const email_field = { required: true, message: 'Please input your E-mail!' };
const mobile_number = {
  required: true,
  message: 'Please input your valid Phone number!',
  transform: (value) => transform(value),
  type: 'number',
  min: 1000000000,
};

const number_manadatory = {
  required: true,
  message: 'Please input valid number!',
  transform: (value) => transform(value),
  type: 'number',
  min: 0,
};

const amount_field = {
  required: true,
  message: 'Please input valid Amount, min. amount is 15',
  transform: (value) => transform(value),
  type: 'number',
  min: 15,
  max: 200000,
};

const email_or_mobile = {
  required: true,
  message: 'Please enter a valid email id or mobile number',
  transform: (value) => {
    if ((/\S+@\S+\.\S+/.test(value) &&
    (value.endsWith('.in') ||
    value.endsWith('.net') ||
    value.endsWith('.org') ||
    value.endsWith('.com') ||
    value.endsWith('.us') ||
    value.endsWith('.uk') ||
    value.endsWith('.info'))) || (/^[0-9]+$/.test(value) && value.length === 10)) {
      return value;
    }
    return false;
  },
};

const otp_mandatory = {
  required: true,
  message: 'Please input valid otp!',
  transform: (value) => transform(value),
  type: 'number',
  min: 0,
};

const transform = (value) => Number(value);

const dob_mandatory = {
  required: true,
  message: 'Please select your date of birth!',
};

const valid_pan_number = {
  required: true,
  message: 'Please provide a valid PAN number',
  type: 'string',
  transform: (value) => {
    const regPan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
    if (regPan.test(value)) {
      return value;
    }
    return false;
  },

};

const validIndianPincode = {
  required: true,
  message: 'Please provide a valid Indian PIN Code',
  type: 'string',
  transform: (value) => {
    const regPincode = /^[1-9][0-9]{5}$/; // Indian PIN codes are 6-digit numbers starting from 1-9
    if (regPincode.test(value)) {
      return value;
    }
    return false;
  },
};

const validAadhaarNumber = {
  required: true,
  message: 'Please provide a valid Aadhaar Number',
  type: 'string',
  transform: (value) => {
    const regAadhaar = /^[1-9][0-9]{11}$/;
    if (regAadhaar.test(value)) {
      return value;
    }
    return false;
  },
};

const valid_mobile_number = {
  required: true,
  message: 'Please provide a valid mobile number starting with either of 6,7,8,9 series and maximum 10 digits only',
  type: 'string',
  transform: (value) => {
    const regMobile = /^[6-9]\d{9}$/;
    if (regMobile.test(value)) {
      return value;
    }
    return false;
  },
};

const maxCharacters = 25;

const validInputField = {
  required: true,
  message: `Please provide a valid input (max ${maxCharacters} characters, only alphabets, and at most one space)`,
  type: 'string',
  transform: (value) => {
    if (typeof value === 'string' && value.trim().length <= maxCharacters) {
      const regAlphabetsOnly = /^[A-Za-z ]+$/; // Only alphabets and space
      const regValidSpace = /^(?!.*\s{2})[A-Za-z ]*$/; // Allows at most one space

      if (regAlphabetsOnly.test(value) && regValidSpace.test(value)) {
        return value.trim();
      }
    }

    return false;
  },
};

const validInputFieldAlphanumeric = {
  required: true,
  message: 'Please provide a valid input, only alphanumeric uppercase characters',
  type: 'string',
  transform: (value) => {
    if (typeof value === 'string') {
      const regAlphabetsOnly = /^[A-Z0-9]+$/;

      if (regAlphabetsOnly.test(value)) {
        return value.trim();
      }
    }

    return false;
  },
};

const amount_field_edit_beneficiary = {
  required: true,
  message: 'Please input your valid Amount',
  transform: (value) => transform(value),
  type: 'number',
  min: 1,
  max: 200000,
};

const transactions_field_edit_beneficiary = {
  required: true,
  message: 'Please input your valid Amount',
  transform: (value) => transform(value),
  type: 'number',
  min: 1,
  max: 10,
};

const validReasonsField = {
  required: true,
  message: 'Min. characters allowed are 5',
  transform: (value) => {
    if (value.length >= 5) {
      return value;
    }
    return false;
  },
};

const validateIFSCField = {
  required: true,
  message: 'Invalid IFSC Code',
  transform: (value) => {
    const cleanedValue = value.replace(/\s/g, '').toUpperCase();
    const isValidLength = cleanedValue.length === 11;
    const isValidFormat = /^[A-Z0-9]{11}$/.test(cleanedValue);

    if (isValidLength && isValidFormat) {
      return cleanedValue;
    }
    return false;
  },
};


export default {
  mandatory,
  email_valid,
  email_field,
  mobile_number,
  number_manadatory,
  amount_field,
  email_or_mobile,
  validIndianPincode,
  validAadhaarNumber,
  dob_mandatory,
  valid_pan_number,
  valid_mobile_number,
  otp_mandatory,
  validInputFieldAlphanumeric,
  validInputField,
  amount_field_edit_beneficiary,
  transactions_field_edit_beneficiary,
  validReasonsField,
  validateIFSCField,
};



// WEBPACK FOOTER //
// client/devUtils/validationRules.js